import(/* webpackMode: "eager" */ "/workspace/apps/dealerportal/app/global-error.tsx");
